import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import CreateProvisionedTargetForm from './form'

function CreateProvisionedTargetDialog ({ open, onClose, onComplete }) {
  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Create Provisioned Target Table'
      size='medium'
    >
      {open ? (
        <CreateProvisionedTargetForm onComplete={onComplete} onCancel={onClose} />
      ) : null}
    </SydModal>
  )
}

CreateProvisionedTargetDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onComplete: PropTypes.func
}

export default CreateProvisionedTargetDialog
